'use client';

import { LandingPageQuestion } from '@/models/LandingPage';
import { useState } from 'react';

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className={`shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="#000"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function LandingFaqAccordion({ questions }: { questions: LandingPageQuestion[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (!questions.length) return null;

  return (
    <div className="flex flex-col gap-4">
      {questions.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={`${item.question}-${index}`}
            className="overflow-hidden rounded-xl border border-[#F0F1F3] bg-white"
          >
            <button
              type="button"
              className="flex w-full items-center justify-between gap-2 px-4 py-4 text-left"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
            >
              <span className="font-poppins text-lg font-semibold leading-6 tracking-[-0.025em] text-[#2E2E2C]">
                {item.question}
              </span>
              <Chevron open={isOpen} />
            </button>
            <div
              className={
                isOpen
                  ? 'border-t border-[#F0F1F3] px-4 pb-4 pt-3 text-sm leading-relaxed tracking-[-0.01em] text-[#5C5C56]'
                  : 'hidden'
              }
            >
              {item.answer}
            </div>
          </div>
        );
      })}
    </div>
  );
}
